// jsaForm/v1/hazCom.actions.js

export const makeJsaV1HazComActions = ({ setJsaUi, bump, emitJsaPatch }) => ({
  updateJsaHazComYes(jsaData, value, emitPatch) {
    jsaData.jsaHazCom.updateHazComUseYes(value);
    const hazComYesFields = { hazComUseYes: value };
    if (!value) {
      hazComYesFields.hazComSdsYes = false;
      hazComYesFields.hazComSdsNo = false;
      hazComYesFields.hazComGasMeterYes = false;
      hazComYesFields.hazComGasMeterNo = false;
    } else {
      hazComYesFields.hazComUseNo = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaHazCom.toPatch(hazComYesFields, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    setJsaUi({
      v1: (prev) => ({
        ...prev,
        hazCom: { ...(prev?.hazCom || {}), showHazComSection: value },
      }),
    });
    bump();
  },

  updateJsaHazComNo(jsaData, value, emitPatch) {
    jsaData.jsaHazCom.updateHazComUseNo(value);
    const hazComNoFields = { hazComUseNo: value };
    if (value) {
      hazComNoFields.hazComUseYes = false;
      hazComNoFields.hazComSdsYes = false;
      hazComNoFields.hazComSdsNo = false;
      hazComNoFields.hazComGasMeterYes = false;
      hazComNoFields.hazComGasMeterNo = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaHazCom.toPatch(hazComNoFields, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    if (value) {
      setJsaUi({
        v1: (prev) => ({
          ...prev,
          hazCom: { ...(prev?.hazCom || {}), showHazComSection: false },
        }),
      });
    } else {
      bump();
    }
  },

  updateJsaHazComSdsYes(jsaData, value, emitPatch) {
    jsaData.jsaHazCom.updateHazComSdsYes(value);
    const sdsYesFields = { hazComSdsYes: value };
    if (value) {
      sdsYesFields.hazComSdsNo = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaHazCom.toPatch(sdsYesFields, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaHazComSdsNo(jsaData, value, emitPatch) {
    jsaData.jsaHazCom.updateHazComSdsNo(value);
    const sdsNoFields = { hazComSdsNo: value };
    if (value) {
      sdsNoFields.hazComSdsYes = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaHazCom.toPatch(sdsNoFields, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaHazComGasMeterYes(jsaData, value, emitPatch) {
    jsaData.jsaHazCom.updateHazComGasMeterYes(value);
    const gasMeterYesFields = { hazComGasMeterYes: value };
    if (value) {
      gasMeterYesFields.hazComGasMeterNo = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaHazCom.toPatch(gasMeterYesFields, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaHazComGasMeterNo(jsaData, value, emitPatch) {
    jsaData.jsaHazCom.updateHazComGasMeterNo(value);
    const gasMeterNoFields = { hazComGasMeterNo: value };
    if (value) {
      gasMeterNoFields.hazComGasMeterYes = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaHazCom.toPatch(gasMeterNoFields, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
});
